import { render, staticRenderFns } from "./add-money.vue?vue&type=template&id=64a000bc&scoped=true"
import script from "./add-money.vue?vue&type=script&lang=js"
export * from "./add-money.vue?vue&type=script&lang=js"
import style0 from "./add-money.vue?vue&type=style&index=0&id=64a000bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a000bc",
  null
  
)

export default component.exports